import axiosService from '@commonClient/services/api';
import appendPath, { toQueryString } from '@services/path';

const BASE_PATH = 'api/v1/manager/audit';
const appendToApiPath = appendPath(BASE_PATH);

export const downloadMultipleBidProfileAuditReportExcel = async (bidProfileIds, language) =>
    axiosService.get(
        appendToApiPath('bidProfile/excel', toQueryString({ bidProfileIds, language })),
        {
            headers: { 'Content-Type': 'blob' },
            responseType: 'arraybuffer',
        },
    );

export const downloadMultipleEmployeeAuditReportExcel = async (bidProfileIds, language) =>
    axiosService.get(
        appendToApiPath('employee/excel', toQueryString({ bidProfileIds, language })),
        {
            headers: { 'Content-Type': 'blob' },
            responseType: 'arraybuffer',
        },
    );
